import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
// fallow-ignore-next-line circular-dependency -- co-located route modules must import their parent route from routes.tsx, which imports this module back into the tree; the same cycle already exists for every migrated route (see the workflow Memories and runs tabs).
import { backgroundAgentsLayoutRoute } from 'src/routes';

// The procedure Versions page (AI-461): a sibling of the (still centrally declared)
// `/agents/procedures/$id` detail route, so its real URL is
// `/agents/procedures/$id/versions`. The `(procedure-detail)` route group keeps the file at the
// path `custom/tanstack-route-file-path` derives from the declared path.
export const Route = createRoute({
  getParentRoute: () => backgroundAgentsLayoutRoute,
  path: 'procedures/$id/versions',
  component: lazyRouteComponent(
    // fallow-ignore-next-line circular-dependency -- the page reads its params from this route via Route.useParams() (the typed-params convention), so it imports this module back; this edge is a lazy dynamic import, so the cycle never closes at module-eval time.
    () => import('../../../../operator/SopVersionsPage'),
    'SopVersionsPage',
  ),
  loader: () => ({ crumb: msg('Versions', { context: 'page breadcrumb' }) }),
});
